/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/11/2021
 */
import {
	where,
	or,
	and,
	limit,
	orderBy,
	startAfter
} from "firebase/firestore"
import {LogicalSymbols} from "@/core/js/backend/filters/LogicalSymbols.js";


export default class BaseFirestoreRef {

	paths
	firestore

	queryConstraints = []
	hasWhereClause: boolean = false

	constructor(firestore, ...paths) {
		this.paths = paths;
		this.firestore = firestore
	}

	// applyFilter(filter){
	// 	let ref = this._createCopy()
	// 	// console.trace("BaseFirestoreRef: applyFilter: filter.filterOptions = ", filter.filterOptions)
	// 	let whereArray = filter.filterOptions.map(option => {
	// 		if(option.field){
	// 			option = where(option.field, option.operation, option.value)
	// 		}
	// 		return option
	// 	})
	// 	ref.queryConstraints = [...ref.queryConstraints, ...whereArray]
	// 	ref.hasWhereClause = true
	// 	console.log("BaseFirestoreRef: applyFilter: ref = ", ref, ", filter.filterOptions = ", filter.filterOptions)
	// 	return ref
	// }


	where(fieldPath, opStr, value){
		let ref = this._createCopy()
		ref.queryConstraints.push(where(fieldPath, opStr, value))
		ref.hasWhereClause = true
		return ref
	}
	whereIf(fieldPath, opStr, value, condition){
		if(condition === undefined && value !== undefined || condition){
			return this.where(fieldPath, opStr, value)
		}
		return this
	}
	or(whereArray){
		return this._orAndInternal(whereArray, or)
	}
	and(whereArray){
		return this._orAndInternal(whereArray, and)
	}

	_orAndInternal(whereArray, fn){
		let arr = []
		whereArray = whereArray.filter(item => !!item)
		for(let w of whereArray){
			arr.push(where(w[0], w[1], w[2]))
		}
		let ref = this._createCopy()
		ref.queryConstraints.push(fn(...arr))
		ref.hasWhereClause = true
		return ref
	}

	limit(limitNumber){
		let ref = this._createCopy()
		ref.queryConstraints.push(limit(limitNumber))
		return ref
	}
	orderBy(fieldPath, directionStr){
		let ref = this._createCopy()
		ref.queryConstraints.push(orderBy(fieldPath, directionStr))
		return ref
	}
	startAfter(snapshot){
		let ref = this._createCopy()
		ref.queryConstraints.push(startAfter(snapshot))
		return ref
	}

	_createCopy(){
		let ref = new this.constructor(this.firestore, ...this.paths)
		ref.queryConstraints.push(...this.queryConstraints)
		ref.hasWhereClause = this.hasWhereClause
		return ref
	}


	orStart(){
		let ref = this._createCopy()
		ref.queryConstraints.push(LogicalSymbols.OR_START)
		return ref
	}
	andStart(){
		let ref = this._createCopy()
		ref.queryConstraints.push(LogicalSymbols.AND_START)
		return ref
	}
	orEnd(){
		let ref = this._createCopy()
		ref.queryConstraints.push(LogicalSymbols.OR_END)
		return ref
	}
	andEnd(){
		let ref = this._createCopy()
		ref.queryConstraints.push(LogicalSymbols.AND_END)
		return ref
	}

	getQueryConstraintsExecuted(){
		let res = []

		let parenthesisStack = []

		for(let i = 0; i < this.queryConstraints.length; i++){
			let constraint = this.queryConstraints[i]
			this.addToParenthesisStack(parenthesisStack, constraint)
			if(constraint === LogicalSymbols.AND_END || constraint === LogicalSymbols.OR_END){
				// let searchFor = constraint === ")" ? "(" : "["
				let searchFor = constraint === LogicalSymbols.AND_END ? LogicalSymbols.AND_START : LogicalSymbols.OR_START

				this.checkParenthesisStack(parenthesisStack, searchFor)

				let local = []
				let popRes = res.pop()
				while(popRes && popRes !== searchFor){
					local.unshift(popRes)
					popRes = res.pop()
				}
				let fn = this.getFnBySymbol(popRes)
				// console.log("getQueryConstraintsExecuted: fn = ", fn, ", local = ", local)
				constraint = fn(...local)
			}
			res.push(constraint)
		}
		this.checkParenthesisStack(parenthesisStack)
		return res
	}

	getFnBySymbol(symbol){
		let fn
		switch (symbol){
			case LogicalSymbols.OR_START:
				fn = or
				break;
			case LogicalSymbols.AND_START:
				fn = and
				break;
			default:
				this.throwInconsistentParenthesis()
		}
		return fn
	}

	addToParenthesisStack(parenthesisStack, constraint){
		if(constraint === LogicalSymbols.OR_START || constraint === LogicalSymbols.AND_START){
			parenthesisStack.push(constraint)
		}
		// console.log("addToParenthesisStack: parenthesisStack = ", parenthesisStack)
	}

	checkParenthesisStack(parenthesisStack, searchFor){
		// console.log("checkParenthesisStack: parenthesisStack = ", parenthesisStack, ", searchFor = ", searchFor)
		if(!searchFor){
			if(parenthesisStack.length > 0){
				this.throwInconsistentParenthesis()
			}
		} else if(parenthesisStack.pop() !== searchFor){
			this.throwInconsistentParenthesis()
		}
	}

	throwInconsistentParenthesis(){
		throw Error("Incorrect balance of orStar/orEnd or andStart/andEnd")
	}


	get converter() {
		return this.getRef().converter
	}

	get type() {
		return this.getRef().type
	}
	get id() {
		return this.getRef().id
	}
	get path() {
		return this.getRef().path
	}
	get parent() {
		return this.getRef().parent
	}

	//undocumented private prop that is used in writeBatch()
	get _key() {
		return this.getRef()._key
	}


	getRef(){

	}

}
